import React, { Component } from "react";
export default class LanguageSpellingSection extends Component {
  render() {
    var {
      spelling_lecture_text,
      spelling_toothpick_text,
      spelling_gathering_text,
      spelling_pollution_text,
      spelling_receipt_text,
      spelling_sunflower_text,
      spelling_inspire_text,
      spelling_argued_text,
      spelling_watermelon_text,
      spelling_dictionary_text,
      spelling_earthquake_text,
      spelling_thought_text,
      spelling_score,
    } = this.props.data;
    return (
      <div className="row border border-dark bg-white">
        <div className="col-lg-12">
          <table className="w-100">
            <tbody>
              <tr>
                <td>
                  <br />
                  <div className="row p-3">
                    <div className="col-lg-6">
                      <span className="fs-19 mb-3">1. Lecture </span>{" "}
                      <input
                        value={spelling_lecture_text}
                        name="spelling_lecture_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-19 mb-3">2. Toothpick </span>{" "}
                      <input
                        value={spelling_toothpick_text}
                        name="spelling_toothpick_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-19 mb-3">3. Gathering </span>
                      <input
                        value={spelling_gathering_text}
                        name="spelling_gathering_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-19 mb-3">4. Pollution </span>{" "}
                      <input
                        value={spelling_pollution_text}
                        name="spelling_pollution_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-19 mb-3">5. Receipt </span>
                      <input
                        value={spelling_receipt_text}
                        name="spelling_receipt_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-19 mb-3">6. Sunflower </span>{" "}
                      <input
                        value={spelling_sunflower_text}
                        name="spelling_sunflower_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-19 mb-3">7. Inspire </span>{" "}
                      <input
                        value={spelling_inspire_text}
                        name="spelling_inspire_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-19 mb-3">8. Argued </span>{" "}
                      <input
                        value={spelling_argued_text}
                        name="spelling_argued_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-19 mb-3">9. Watermelon </span>{" "}
                      <input
                        value={spelling_watermelon_text}
                        name="spelling_watermelon_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-19 mb-3">10. Dictionary </span>{" "}
                      <input
                        value={spelling_dictionary_text}
                        name="spelling_dictionary_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-19 mb-3">11. Earthquake </span>{" "}
                      <input
                        value={spelling_earthquake_text}
                        name="spelling_earthquake_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-19 mb-3">12. Thought </span>
                      <input
                        value={spelling_thought_text}
                        name="spelling_thought_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                  </div>
                  <hr />
                  <div className="col-lg-6">
                    <span className="fs-19">Score (0-12) </span>
                    <input
                      type="number"
                      disabled
                      name="spelling_score"
                      value={spelling_score}
                      className="ecas-input-field"
                      placeholder="Score"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
